var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19491 7.77181C-0.398305 5.55089 -0.398305 2.44944 1.19491 0.228524C1.37619 -0.0236957 1.71958 -0.0739035 1.95847 0.1147C2.20053 0.304407 2.24854 0.662109 2.06724 0.914901C0.765179 2.73126 0.765179 5.26911 2.06724 7.08543C2.24851 7.33822 2.20053 7.69589 1.95847 7.88563C1.71671 8.07538 1.37426 8.02331 1.19491 7.77181Z",
    fill: "#FF284F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0428 7.8856C9.80072 7.69589 9.75271 7.33819 9.93401 7.0854C11.2361 5.26904 11.2361 2.73118 9.93401 0.914863C9.75274 0.662071 9.80072 0.304407 10.0428 0.114661C10.2827 -0.0745136 10.6261 -0.024839 10.8063 0.228486C12.3996 2.4494 12.3996 5.55086 10.8063 7.77178C10.627 8.0232 10.2846 8.07542 10.0428 7.8856Z",
    fill: "#FF284F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15153 6.6669C1.85053 5.14688 1.85053 2.85344 3.15153 1.33337C3.35308 1.09788 3.69858 1.07948 3.92255 1.28873C4.14648 1.49908 4.1657 1.86071 3.96415 2.09563C3.03531 3.18154 3.03531 4.81874 3.96415 5.90464C4.1657 6.13957 4.14652 6.50116 3.92255 6.71155C3.69818 6.92118 3.35311 6.90293 3.15153 6.6669Z",
    fill: "#FF9DAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07572 6.71154C7.85178 6.50119 7.83256 6.13956 8.03411 5.90463C8.96296 4.81873 8.96296 3.18152 8.03411 2.09562C7.83256 1.86069 7.85175 1.49911 8.07572 1.28871C8.29968 1.07832 8.64519 1.09676 8.84674 1.33336C10.1477 2.85338 10.1477 5.14683 8.84674 6.66689C8.64552 6.9025 8.30048 6.92155 8.07572 6.71154Z",
    fill: "#FF9DAF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00127 5.71435C5.09805 5.71435 4.36328 4.94538 4.36328 4.00012C4.36328 3.05485 5.09805 2.28589 6.00127 2.28589C6.9045 2.28589 7.63926 3.05485 7.63926 4.00012C7.63926 4.94538 6.9045 5.71435 6.00127 5.71435Z",
    fill: "#FF284F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveNotification);
export default __webpack_public_path__ + "static/media/liveNotification.e5c88b5922ea300a56a6fa9cb5abf2e4.svg";
export { ForwardRef as ReactComponent };